import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";

import { ApplicationConfigurationService } from "@app/core/services/ApplicationConfiguration.service";
import {
    PhmsCreatedInmateDto,
    PhmsInmateCreateRequest,
    PhmsInmateCsvImportRequest,
    PhmsInmateCsvImportResultDto,
    PhmsInmateIntakeOptionsDto,
} from "./phms-create-inmate.models";

const BASE_PATH = "/api/phms/inmates";

const quietHttpOptions = {
    headers: new HttpHeaders({
        "skip-error-interceptor": "yes",
        "skip-loading-interceptor": "yes",
    }),
    withCredentials: true,
};

@Injectable({ providedIn: "root" })
export class PhmsCreateInmateService {
    private readonly http = inject(HttpClient);
    private readonly appConfig = inject(ApplicationConfigurationService);

    createInmate(request: PhmsInmateCreateRequest): Observable<PhmsCreatedInmateDto> {
        return this.http.post<PhmsCreatedInmateDto>(
            this.appConfig.apiUrl(BASE_PATH),
            request,
            quietHttpOptions,
        );
    }

    importCsv(request: PhmsInmateCsvImportRequest): Observable<PhmsInmateCsvImportResultDto> {
        return this.http.post<PhmsInmateCsvImportResultDto>(
            this.appConfig.apiUrl(`${BASE_PATH}/import`),
            request,
            quietHttpOptions,
        );
    }

    getIntakeOptions(): Observable<PhmsInmateIntakeOptionsDto> {
        return this.http.get<PhmsInmateIntakeOptionsDto>(
            this.appConfig.apiUrl(`${BASE_PATH}/intake-options`),
            quietHttpOptions,
        );
    }
}
